export const chip = {
  root: {
    borderRadius: "{border.radius.4}",
    paddingX: "{padding.8}",
    paddingY: "{padding.4}",
    gap: "{gap.8}",
    transitionDuration: "{transition.duration}",
  },
  // image: {
  //   width: "2rem",
  //   height: "2rem",
  // },
  icon: {
    size: "{icon.size}",
    fontSize: "12px",
  },
  removeIcon: {
    size: "{icon.size}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}",
    },
  },
  colorScheme: {
    light: {
      root: {
        background: "{highlight.support}",
        color: "{text.body}",
      },
      icon: {
        color: "{chip.color}",
      },
      removeIcon: {
        color: "{chip.color}",
      },
    },
    dark: {
      root: {
        background: "{highlight.support}",
        color: "{text.body}",
      },
      icon: {
        color: "{chip.color}",
      },
      removeIcon: {
        color: "{chip.color}",
      },
    },
  },
};
